<!-- HISTORY: has this.log(msg)
   V260811.1: Added the isAssociationTypeChanged prop and passed it to the post message and removed event listener before adding a new one.
   V260107.1: Added token to the iframeUrl of iframe's src.
   V251217.1: 1st version/release (Was originally copied from BtGenericApp703.vue and then consumed for uploading app iframes).
-->
<template>
   <div>
      <v-tooltip left>
         <template v-slot:activator="{ on }">
            <v-btn text icon
               v-on="on"
               @click="btnClicked"
            >
               <v-icon>{{btnIconName}}</v-icon>
            </v-btn>
         </template>
         <span>{{btnTooltip}}</span>
      </v-tooltip>

      <v-dialog no-click-animation persistent scrollable
         max-width="1080px"
         v-model="dialog"
      >
         <v-card flat :loading="!iframeLoaded">
            <v-card-title class="title grey--text darken-4 font-weight-bold">Instruction for {{appName}}
            </v-card-title>

            <v-card-text>
               <iframe
                  ref="iframeRef"
                  frameborder="0"
                  width="100%"
                  height="500"
                  @load="onIframeLoad"
                  :src="`${iframeUrl}?token=${this.$store.getters.token}${isLocal ? '&isLocal' : ''}`"
               ></iframe>
            </v-card-text>
         </v-card>
      </v-dialog>
   </div>
</template>

<script>
import { isLocal } from '../mixins/bt-mixin.js';

const NAME = "BtApps";
const VERSION = 'V260107.1';

function _isNonEmptyObject(obj) {
  return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length > 0;
}

export default {
   name: NAME,

   props: {
      value: {
         type: Object,
         required: true,
         default: () => {}
      },
      appName: {
         type: String,
         default: ""
      },
      associationType: {
         type: Array,
         required: true
      },
      // V260811
      isAssociationTypeChanged: {
         type: Boolean,
         required: true
      },
      btnIconName: {
         type: String,
         default: "more_vert"
      },
      btnTooltip: {
         type: String,
         default: "click to configure"
      },
      debug: {
         type: Boolean,
         default: false
      },
      iframeUrl: {
         type: String,
         required: true
      }
   },

   data() {
      return {
         isLocal,
         dialog: false,
         messageHandled: false,
         iframeLoaded: false
      }
   },

   methods: {
      log(msg) {
         if (this.debug) {
            console.log(`-----${NAME} ${VERSION} says => ${msg}`);
         }
      },

      btnClicked() {
         // alert('in btnClicked(): this.value=' + JSON.stringify(this.value));
         // V260811
         window.removeEventListener('message', this.handleMessage);         
         
         window.addEventListener('message', this.handleMessage);
         this.dialog = true;
         if (this.iframeLoaded)
            setTimeout(() => {
               this.sendMessage();
            }, 10);
      },

      onIframeLoad() {
         setTimeout(() => {
            this.iframeLoaded = true;
            this.sendMessage();
         }, 10);
      },

      sendMessage() {
         if (this.$refs.iframeRef && this.$refs.iframeRef.contentWindow) {
            const postMsg = this.value.instruction ? this.value : { instruction: {} };
            postMsg.associationType = this.associationType;
            // V260811: Passing value only in edit mode.
            postMsg.isAssociationTypeChanged = _isNonEmptyObject(postMsg.instruction)
               ? this.isAssociationTypeChanged
               : false;                

            this.log('in sendMessage(): postMsg=' + JSON.stringify(postMsg));
            this.$refs.iframeRef.contentWindow.postMessage(postMsg, '*');
            this.messageHandled = false;
         }
      },

      handleMessage(event) {
         if (this.messageHandled) return;

         if (event.data && typeof event.data === "object" && "isCancelled" in event.data) {
            this.messageHandled = true;

            if (!event.data?.isCancelled && _isNonEmptyObject(event.data?.instruction)) {
               const { instruction, consumerCode, appEndpoint } = event.data;
               const result = { instruction, consumerCode, appEndpoint };
               // V260811
               this.isAssociationTypeChanged = false;

               this.$emit('change', result);
               this.$emit('input', result);
            }

            window.removeEventListener('message', this.handleMessage);         
            this.dialog = false;
         }
      }
   },

   created() {
      // alert(`in ${NAME}.created(): iframeUrl=${this.iframeUrl}`);
   }
}
</script>

<style scoped>
iframe {
   border: 1px solid #ccc;
   border-radius: 8px;
}
</style>
